/* eslint-disable no-unused-vars */
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@material-ui/core';
import React, { forwardRef, useEffect, useImperativeHandle, useState, } from 'react';
import { DuoColumnSelector } from '../../../../../commons/DuoColumnSelector';
import { CustomHelperText } from '../../Sequence.Styles';
import { Wrapper } from './FilteringAndSorting.Styles';
var filteringAndSorting = function (_props, ref) {
    var _a = useState([]), contactFilters = _a[0], setContactFilters = _a[1];
    var _b = useState([]), phoneFilters = _b[0], setPhoneFilters = _b[1];
    var _c = useState([]), contactSorting = _c[0], setContactSorting = _c[1];
    var _d = useState(false), contactFiltersTouched = _d[0], setContactFiltersTouched = _d[1];
    var _e = useState(false), phoneFiltersTouched = _e[0], setPhoneFiltersTouched = _e[1];
    var _f = useState(false), contactSortingTouched = _f[0], setContactSortingTouched = _f[1];
    var _g = useState([]), contactFilterValues = _g[0], setContactFilterValues = _g[1];
    var _h = useState([]), phoneFilterValues = _h[0], setPhoneFilterValues = _h[1];
    var _j = useState([]), contactSortingValues = _j[0], setContactSortingValues = _j[1];
    var _k = useState(false), openAlert = _k[0], setOpenAlert = _k[1];
    function isValidFilter(filter) {
        var _a;
        var contactList = _props === null || _props === void 0 ? void 0 : _props.contactLists.filter(function (cl) { var _a, _b; return (cl === null || cl === void 0 ? void 0 : cl.id) === ((_b = (_a = _props === null || _props === void 0 ? void 0 : _props.campaign) === null || _a === void 0 ? void 0 : _a.BaseConfig) === null || _b === void 0 ? void 0 : _b.ContactListConfigID); });
        return ((_a = contactList[0]) === null || _a === void 0 ? void 0 : _a.ContactListTable) === (filter === null || filter === void 0 ? void 0 : filter.tableCL);
    }
    useEffect(function () {
        var _a;
        if (contactFilters) {
            var validFilters = (_a = _props.contactFilters) === null || _a === void 0 ? void 0 : _a.filter(function (filter) {
                return isValidFilter(filter);
            });
            setContactFilterValues(validFilters === null || validFilters === void 0 ? void 0 : validFilters.map(function (filter) {
                return {
                    value: filter.id,
                    label: filter.filterName
                };
            }));
        }
    }, [_props.contactFilters, _props === null || _props === void 0 ? void 0 : _props.campaign]);
    useEffect(function () {
        var _a;
        if (phoneFilters) {
            var validFilters = (_a = _props.phoneFilters) === null || _a === void 0 ? void 0 : _a.filter(function (filter) {
                return isValidFilter(filter);
            });
            setPhoneFilterValues(validFilters === null || validFilters === void 0 ? void 0 : validFilters.map(function (filter) {
                return {
                    value: filter.id,
                    label: filter.filterName
                };
            }));
        }
    }, [_props.phoneFilters, _props === null || _props === void 0 ? void 0 : _props.campaign]);
    useEffect(function () {
        var _a;
        if (contactSorting) {
            var validFilters = (_a = _props.contactSorting) === null || _a === void 0 ? void 0 : _a.filter(function (filter) {
                return isValidFilter(filter);
            });
            setContactSortingValues(validFilters.map(function (filter) {
                return {
                    value: filter.id,
                    label: filter.filterName
                };
            }));
        }
    }, [_props.contactSorting, _props === null || _props === void 0 ? void 0 : _props.campaign]);
    useImperativeHandle(ref, function () { return ({
        getValues: function () {
            setContactFiltersTouched(true);
            setPhoneFiltersTouched(true);
            setContactSortingTouched(true);
            return { contactFilters: contactFilters, phoneFilters: phoneFilters, contactSorting: contactSorting };
        },
        reSet: function () {
            setContactFiltersTouched(false);
            setPhoneFiltersTouched(false);
            setContactSortingTouched(false);
            setContactFilters([]);
            setPhoneFilters([]);
            setContactSorting([]);
        },
        setData: function (data) {
            setContactFilters(data.contactFilters);
            setPhoneFilters(data.phoneFilters);
            setContactSorting(data.contactSorting);
        }
    }); });
    var reHydrate = function () { };
    return (React.createElement(Wrapper, null,
        React.createElement(React.Fragment, null,
            React.createElement(DuoColumnSelector, { name: 'contactFilters', label: 'Contact Filters', itemOptions: JSON.parse(JSON.stringify(contactFilterValues)), dependency: contactFilterValues, values: contactFilters, onChange: function (e) {
                    setContactFilters(e);
                    setContactFiltersTouched(true);
                } }),
            contactFilters.length === 0 && contactFiltersTouched && (React.createElement(CustomHelperText, { error: true }, "This Field is Required"))),
        React.createElement(React.Fragment, null,
            React.createElement(DuoColumnSelector, { name: 'phoneFilters', label: 'Phone Filters', itemOptions: JSON.parse(JSON.stringify(phoneFilterValues)), dependency: phoneFilterValues, values: phoneFilters, onChange: function (e) {
                    setPhoneFilters(e);
                    setPhoneFiltersTouched(true);
                } })),
        React.createElement(DuoColumnSelector, { name: 'contactSorting', label: 'Contact Sorting', itemOptions: JSON.parse(JSON.stringify(contactSortingValues)), dependency: contactSortingValues, values: contactSorting, onChange: function (e) {
                setContactSorting(e);
                setContactSortingTouched(true);
            } }),
        React.createElement(Button, { variant: "contained", color: "primary", onClick: function () { setOpenAlert(true); } }, "Validate Filters"),
        React.createElement(Dialog, { open: openAlert, onClose: function () { return setOpenAlert(false); }, "aria-labelledby": 'alert-delete', "aria-describedby": 'alert-dialog-description' },
            React.createElement(DialogTitle, { id: 'alert-delete' }, "Validate Filters"),
            React.createElement(DialogContent, null,
                React.createElement(DialogContentText, { id: 'alert-dialog-description' }, "Validation request can take up to 10 mins. Are you sure you want to proceed?")),
            React.createElement(DialogActions, null,
                React.createElement(Button, { onClick: function () { return setOpenAlert(false); }, color: 'primary' }, "Cancel"),
                React.createElement(Button, { onClick: function () {
                        _props.onValidateFilters();
                        setOpenAlert(false);
                        // setOpenValidationResult(true)
                    }, color: 'primary', autoFocus: true }, "Proceed")))));
};
export var FilteringAndSorting = forwardRef(filteringAndSorting);
//# sourceMappingURL=FilteringAndSorting.js.map